
// === datepickerInitializer.js START =============================================================

/**
 * Initializes the JQuery-UI datepicker module and sets a clickevent on body to close datepicker
 * on clicks outside the datepicker module.
 * - requires initialized FullCalendar
 */
function InitDatepicker(locale, $container) {
    var $datepicker = $container.find('.m-mamp-datepicker--header');
    if ($datepicker.length != 0) {
        return $datepicker;
    }
    //culture
    function setDatepickerLocale(culture) {
        if ($.datepicker.regional.hasOwnProperty(culture)) {
            $.datepicker.setDefaults($.datepicker.regional[culture]);
            return true;
        }
        return false;
    }

    if (!setDatepickerLocale(locale)) {
        var localeJustLanguage = locale.split('-')[0];
        setDatepickerLocale(localeJustLanguage);
    }
    //
    $(document.body).click(function (event) {
        var $target = $(event.target);
        if ($datepicker.is(':visible')
            && $target.closest('.fc-toolbar__icon-button--date').length == 0
            && $target.closest('.ui-datepicker-header').length == 0
            && $target.closest('.m-mamp-datepicker').length == 0) {
            $datepicker.hide();
        }
    });
    //initialize
    $datepicker = $("<div>")
        .addClass("m-mamp-datepicker m-mamp-datepicker--header")
        .hide()
        .appendTo($container);

    $datepicker.datepicker({
        dateFormat: dateTimeFormatString.dateFormatPicker,
        onSelect:
            function (date) {
                $calendar.fullCalendar('gotoDate', moment(date, dateTimeFormatString.dateFormat));
                $(this).datepicker('setDate', date);
                $(this).hide();
            }
    });

    return $datepicker;
}

// === datepickerInitializer.js END ===============================================================
